import { atom, AtomEffect } from "recoil";

export type DashboardCardId =
    | "workspace-requests"
    | "offer-requests"
    | "affiliate-payouts"
    | "advertiser-payouts"
    | "daily-overview"
    | "latest-transactions"
    | "invite-partners"
    | "unique-link"
    | "best-offers"
    | "best-affiliates"
    | "user-group";

export interface DashboardState {
    order: DashboardCardId[];
    hidden: DashboardCardId[];
    pinnedOfferIds: string[];
}

const persist =
    (key: string): AtomEffect<DashboardState> =>
    ({ setSelf, onSet }) => {
        try {
            const raw = typeof window !== "undefined" ? localStorage.getItem(key) : null;
            if (raw) setSelf(JSON.parse(raw));
        } catch {
            // ignore malformed or unavailable storage
        }
        onSet((val) => {
            try {
                if (typeof window !== "undefined") {
                    localStorage.setItem(key, JSON.stringify(val));
                }
            } catch {
                // ignore quota/storage errors
            }
        });
    };

export const dashboardStateAtom = atom<DashboardState>({
    key: "dashboardState",
    default: {
        order: [
            "workspace-requests",
            "offer-requests",
            "affiliate-payouts",
            "advertiser-payouts",
            "daily-overview",
            "latest-transactions",
            "invite-partners",
            "unique-link",
            "best-offers",
            "best-affiliates",
            "user-group",
        ],
        hidden: [],
        pinnedOfferIds: [],
    },
    effects: [persist("dashboardState:v1")],
});
